<template>
    <div class="body">
            <div class="imgList">
                  <el-row>
                    <el-col :span="6" v-for="(item, index) in tableData" :key="index" :offset="index > 0 ? 0 : 0">
                      <el-card  class="card">
                        <img :src="item.imgUrl" class="image">
                          <div class="bottom clearfix">
                            <el-button type="primary" @click="deleteImg(item)" >删除</el-button>
                          </div>
                      </el-card>
                    </el-col>
                  </el-row>
                  <el-upload class="avatar-uploader" action="http://shine.qiouou.com:9000/admin/a1/store-product/save" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <el-button type="primary" class="addImg" @click="addImg" >确认添加</el-button>
            </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('product')
  export default {
    data() {
      return {
          currentDate: new Date(),
          dialogImageUrl: '',
          dialogVisible: false,
          tableData: [],
          imageUrl:'',
          file:'',
          form:{
            id:null,
            imgUrl:'',
            productId:'',
          },

        };
    },
    mounted(){
        this.form.productId = this.id
        this.home(this.id);
    },
    computed:{
      ...mapState({
        id:state=>state.productId
      })
    },
    methods: {

      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.file = file.raw
      },

       beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'||'image/png'||'image/jpg'||'image/jpg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },

      //图片列表
      home(id){
           let that = this
            this.joker.store.slideOne(this.id).then(res=>{
                  console.log(res)
                  that.tableData = res.content
                  console.log(that.tableData)
            }).catch(res=>{
            })
      },
      //添加图片
      addImg(){
          let  formData = new FormData();
          formData.append('productId',this.id)
          formData.append('coverFile',this.file)
          this.joker.store.addSlide(formData).then(res=>{
             alert('添加成功')
             this.home(this.id);
          }).catch(res=>{
             console.log(res)
          })
      },

      deleteImg(item){
          console.log(item)
          this.joker.store.deleteSlide(item.id).then(res=>{
             alert('删除成功')
             this.home(this.id);
          }).catch(res=>{
             console.log(res)
          })
      },
    }
  }
</script>


<style scoped>

.addImg{
  margin-bottom: 2%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .imgList{
    background-color: #ffffff;
    padding-top: 2%;
  }


   .time {
    color: #999;
  }
  
  .button {
    padding: 0;
    float: right;
  }

  .image {
    width:300px;
    height: 300px;
    display: block;
  }

  .card{
    width: 350px;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

</style>


// WEBPACK FOOTER //
// src/components/Store/StoreSlide.vue